import {EntityScopeEnum} from "@docma-mm-core/entity/entity-scope.enum";
import { Project } from "@docma-mm-core/project/project";
import { User } from '@docma-mm-core/user/user';

export class Filter {

  constructor(init?: Partial<Filter>) {
    if (init) {
      Object.assign(this, init);
    }
  }

  Id?: number;
  Name?: string;
  User?: User;
  Project? : Project;
  Scope?: EntityScopeEnum;
}
